<template>
    <section>
        <div class="modal-card" style="width: 50vw; height: 70vh">
            <header class="modal-card-head">
                <p class="modal-card-title">{{ __('strings.discount.discount_status') }}</p>
                <button
                    type="button"
                    class="delete"
                    @click="$emit('toggleDiscountStatusModal')"/>
            </header>
            <section class="modal-card-body">
                <div class="is-flex is-justify-content-space-between is-align-items-center">
                    <div class="columns is-fullwidth">
                        <div class="column is-one-quarter">
                            <b-field :label="__('strings.discount.status')">
                                <b-select v-model="filters.status" @input="handleOnChangeStatus" expanded>
                                    <option value="null">{{ __('strings.discount.all') }}</option>
                                    <option value="scheduled">Scheduled</option>
                                    <option value="applied">Applied</option>
                                </b-select>
                            </b-field>
                        </div>
                    </div>
                    <div>
                        <b-button
                            icon-left="autorenew"
                            @click="handleOnClickRefresh">
                        </b-button>
                    </div>
                </div>
                <b-table :data="discounts"
                         :total="discounts.length"
                         :per-page="10"
                         :loading="tableShouldLoad"
                         paginated
                         striped bordered>
                    <b-table-column label="Data di inizio" v-slot="props">
                        {{ getHumanDate(props.row.start_date) }}
                    </b-table-column>
                    <b-table-column label="Data fine" v-slot="props">
                        {{ getHumanDate(props.row.end_date) }}
                    </b-table-column>
                    <b-table-column label="Sconti" v-slot="props">
                        {{ `${props.row.discount} %` }}
                    </b-table-column>
                    <b-table-column label="Articoli" v-slot="props">
                        {{ props.row.product_ids }}
                    </b-table-column>
                    <b-table-column label="Stato" v-slot="props">
                        {{ props.row.status.toUpperCase() }}
                    </b-table-column>
                    <b-table-column label="Website" v-slot="props">
                        {{ getWebsites(props.row) }}
                    </b-table-column>
                    <b-table-column label="File" v-slot="props" >
                        <div v-if="props.row.file_name">
                        <b-button type="is-primary" class="is-uppercase"
                                  @click="download($event, props.row.file_name)" v-show="props.row.file_name">
                            {{ __('strings.discount.downloadfile') }}
                        </b-button>
                        </div>
                        <span v-if="!props.row.file_name">{{__('strings.discount.manually_created')}}</span>
                    </b-table-column>
                </b-table>
            </section>
        </div>
    </section>
</template>

<script>
import moment from "moment";

export default {
    props: {
        websites: {
            required: true,
            type: Array
        },
    },
    data() {
        return {
            tableShouldLoad: false,
            discounts: [],
            filters: {
                status: undefined
            }
        }
    },
    mounted() {
        this.handleDiscountProductSearch();
    },
    methods: {
        handleDiscountProductSearch() {
            this.tableShouldLoad = true;
            const conf = {};
            if (this.filters.status !== "null") {
                conf.params = this.filters;
            }

            axios.get('/discount/plan/status',conf)
                .then(response => {
                    this.discounts = response.data;
                    this.discounts.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
                }).catch((error) => {
                console.error(error);
                this.tableShouldLoad = false
            }).finally(() => {
                    this.tableShouldLoad = false;
            });
        },
        handleOnChangeStatus(value) {
            this.filters.status = value;
            this.handleDiscountProductSearch();
        },
        handleOnClickRefresh() {
            this.handleDiscountProductSearch();
        },
        getHumanDate(date) {
            return moment(date).format('DD MMM YYYY HH:mm');
        },
        getWebsites(row) {
            const website = this.websites.find((w)=>w.id==row.website_id);
            if(website){
                return website.name;
            }
            return row.website_id;
        },
        download(event, fileName) {
            console.log('oggetto', event);

            let btn= event.currentTarget;

            //same thing, doesn't update immediately
            btn.disabled = true;


            axios.get("discount/download/plans/"+fileName, {responseType: 'blob'})
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data],{type: 'text/csv'}));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();

                    btn.disabled = false;
                })
                .catch(e => {
                    console.log(e);
                    btn.disabled = false;
                });
        }
    }
}
</script>

